exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#elevators{contain:layout}#elevators tr{cursor:pointer}#elevators .status-cell{width:20px;min-width:20px;max-width:20px;padding-right:0}#elevators .row-link{color:inherit;text-decoration:none}.filter-panel{overflow:hidden;max-height:0;transition:max-height .35s ease;will-change:max-height;transform:translateZ(0)}.filter-panel-open{max-height:1000px}.filter-panel-content{border:1px solid #dee2e6;border-radius:0 .25rem .25rem .25rem;padding:.75rem 1rem .5rem}.column-drag-item{display:flex;align-items:center;margin-bottom:4px}.drag-handle{cursor:grab;margin-right:6px;color:#aaa;user-select:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21c5edca","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Elevators.vue
// module id = 810
// module chunks = 0